import { ComponentPortal } from '@angular/cdk/portal';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatSpinner } from '@angular/material/progress-spinner';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Tempo } from 'src/app/instant-analysis/models/tempo';
import { HistoryService } from '../services/history/history.service';
import { Overlay } from '@angular/cdk/overlay';
import { FeatureCollection, Point } from '@turf/helpers';
import { ColorType } from 'src/app/instant-analysis/models/color-type';
import { HeatmapType } from 'src/app/instant-analysis/models/heatmap-type';
import { EstacaoTempoChuva, GrupoChuvaEstacao } from '../models/grupo-chuva-estacao';
import { ConfigGraficoChuvas } from '../models/config-grafico-chuvas';
import { TimespanService } from 'src/app/instant-analysis/services/timespan/timespan.service';
import { TimeResolution } from '../models/time-comparator/time-resolution';
import { EventsConfig } from 'src/app/instant-analysis/models/events-config';
import { TimeResolutionInDays } from '../models/time-comparator/time-resolution-in-days';
import { MapConfig } from 'src/app/instant-analysis/models/map-config';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Analise } from 'src/app/dashboard/models/analise';
import { MathAux } from 'src/app/instant-analysis/services/math-aux/math-aux';
import { Geometry } from 'geojson';
import { QueryProgressService } from '../services/query-progress/query-progress.service';
import { VoronoiService } from 'src/app/instant-analysis/services/voronoi/voronoi.service';
import { StartableFromRouter } from 'src/app/dashboard/models/startable-from-router';
import { TimeFormatter} from 'src/app/instant-analysis/utils/time-formatter'
import { routerToMainService } from 'src/app/instant-analysis/services/routerToMainService';
import { ToolbarComponent } from 'src/app/instant-analysis/toolbar/toolbar.component';
import { ServiceService } from 'src/app/instant-analysis/services/service.service';
import { TimeFormatterService } from 'src/app/shared/util/time-formatter';
import { SocketIoServerService } from 'src/app/instant-analysis/services/socket-io-server/socket-io-server.service';
import { MapConfigService } from 'src/app/shared/services/map-config/map-config.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent extends ToolbarComponent implements OnInit, StartableFromRouter {
  

  /**
   * 
   * @param service 
   * @param overlay 
   * @param snackBar 
   * @param routerMessager 
   * @param historyService 
   * @param timespanService 
   * @param queryProgressService 
   * @param voronoiService 
   */
  constructor(
    service: ServiceService,
    overlay: Overlay, 
    snackBar: MatSnackBar, 
    routerMessager: routerToMainService,
    timeFormatterService: TimeFormatterService,
    dataImportedListener: SocketIoServerService,
    mapConfigService: MapConfigService,
    private historyService: HistoryService,
    private timespanService: TimespanService,
    private queryProgressService: QueryProgressService,
    private voronoiService: VoronoiService,
    ) {
      super(service, overlay, snackBar, routerMessager, null, dataImportedListener, timeFormatterService, mapConfigService);
    }

  menuIndex: number = null;
  opened = false;

  /** vetores no formato [dia, mes, ano, hora, minuto] com dados de agora e um mês atrás*/
  now = TimeFormatter.getNow()
  monthAgo = TimeFormatter.getMonthAgo()

  startDate = this.monthAgo[2] + "-" + this.monthAgo[1] + "-" + this.monthAgo[0];
  startTime = this.now[3] + ":" + this.now[4];
  endDate   = this.now[2] + "-" + this.now[1] + "-" + this.now[0];
  endTime   = this.now[3] + ":" + this.now[4];
  tilesize = 0.1;
  intervalo = 24;
  percentil = [10,90];
  heatmaptype = [false,false,true, false];
  aggregateRainInterval: TimeResolution = TimeResolution.ONE_HOUR;
  typeofcalculation = 1

  /** Progresso (0 a 100) da consulta de chuva no intervalo de tempo para construir a heat matrix  */
  intervalQueryProgressPercentage: number = 0;

  /** Progresso (0 a 100) da consulta de agregados de chuva no intervalo de tempo para construir o gráfico de linhas */
  aggregatesQueryProgressPercentage: number = 0;

  mapConfig : MapConfig = this.mapConfigService.intervalMapConfig;

  heatmapConfig = [
    { id: 1, layerType: 1, colorType: ColorType.CONTINUOUS, },
    { id: 2, layerType: 1, tilesizeInKm: this.tilesize, colorType: ColorType.CONTINUOUS, },
    { id: 3, layerType: 1, colorType: ColorType.CONTINUOUS, },
    { id: 4, layerType: 1, colorType: ColorType.CONTINUOUS, },
    { id: 5, layerType: 1, colorType: ColorType.CONTINUOUS },
    { id: 6, layerType: 2, colorType: null },
    { id: 7, layerType: 2, colorType: null },
    { id: 8, layerType: 2, colorType: null },
  ];

  timestamp = 'total'

  // Tipo de exibição das vias:
  // 1 - contínua
  // 2 - discreta
  highwayType = 2;

  /** Porcentagem de completude dos acumulados de chuva. */
  completeness: number = 0;

  selectedHeatmapType = 2;

  /** Opções para o select da let map dados. */
  dataSourceOptions = [
    { 'text': 'Todas', 'value': ['PREFEITURA NITERÓI', 'CEMADEN'] },
    { 'text': 'Prefeitura de Niterói', 'value': ['PREFEITURA NITERÓI'] },
    { 'text': 'CEMADEN', 'value': ['CEMADEN'] },
  ];

  /** Fonte dos dados: prefeitura, cemaden, ou ambos. */
  dataSource: string[] = this.dataSourceOptions[0].value;

  Tempos$: Observable<Tempo[]>[] = [];
  Chuvas$: Observable<{stationsStats: FeatureCollection<Geometry>, neighborhoodsStats: FeatureCollection<Geometry>}>;
  Eventos$: Observable<GeoJSON.FeatureCollection<Point>>;
  Agregados$: Observable<GrupoChuvaEstacao[]>;
  RainIntervalQueryProgress$: Subscription;
  RainInterval$: Subscription;

  rainValues: FeatureCollection<Point>[] = []
  
  /**
   * Textos do tooltips do sidebar.
   */
  firstTooltipText:string = "Liga a atualização do mapa em tempo real, ou seleciona um instante específico. Define, em horas e minutos, o tamanho da janela de ocorrências.";
  secondTooltipText:string = "Alterna a coloração de cada camada entre contínua e discreta. Define os percentis inferior e superior para a coloração contínua.";
  thirdTooltipText:string = "Filtra estações pela completude e pela fonte dos dados.";
  fourthTooltipText:string = "Salva as configurações atuais do mapa e das camadas como uma análise.";

  @Output() close = new EventEmitter<boolean>();
  @Output() json = new EventEmitter<any>(); 
  @Output() rainValuesInInterval = new EventEmitter<any[]>();
  @Output() rainEvents = new EventEmitter<EventsConfig>();
  @Output() rainAggregates = new EventEmitter<ConfigGraficoChuvas>();
  @Output() tempos = new EventEmitter<Tempo[]>();
  @Output() rainChartLoading = new EventEmitter<boolean>();
  @Output() generateReport = new EventEmitter<any>();

  /** */
  @Output() newTimeSearch = new EventEmitter<MapConfig>();

  /** EventEmitter da contagem de ocorrências por células de voronoi */
  @Output() voronoiEventsCount = new EventEmitter<any>();

  ngOnInit(): void {
  }

  toggleConfigPanel() {
    this.close.emit(false);
  }

  setMenuIndex(index: number) {
    this.menuIndex = index;
  }

  /**
   * 
   */
  useSocket() {

    let timeErrorMessage = 'O tempo inicial deve ser anterior ao tempo final';
    if(!this.testDates(timeErrorMessage) || !this.testPercentile() || !this.testTileSize()) {
      return;
    }

    let startDateTime = this.getStartDateTime();
    let endDateTime = this.getEndDateTime();

    // let mapConfig: MapConfig = {
    //   startDatetime: startDateTime,
    //   endDatetime: endDateTime,
    //   newSearch: true,
    //   percentile: this.percentil,
    //   tilesize: this.tilesize,
    //   selectedTimestamp: this.timestamp,
    //   highwayTypes: this.getColorTypes(),
    //   firstStations: {estacao: false, interpolado: false, vias: false, rios: false},
    //   dataSource: this.dataSource,
    //   completeness: 0,
    // };
    this.newTimeSearch.emit();

    return
  }

  /**
   * 
   * @returns 
   */
  getStartDatetimeStr(): string {
    return `${this.startDate} ${this.startTime}`;
  }

  /**
   * 
   * @returns 
   */
  getEndDatetimeStr(): string {
    return `${this.endDate} ${this.endTime}`;
  }

  /**
   * Busca os dados dos agregados de chuvas para a construção do gráfico de linhas
   */
  private fetchRainAggregatesForChart() {

    this.rainChartLoading.emit(true);

    let startDateTime = this.getStartDateTime();
    let endDateTime = this.getEndDateTime();
    this.calcAggregateRainInterval();
    this.Agregados$ = this.historyService.getRainDataAggregatesInInterval(
      startDateTime, endDateTime, this.aggregateRainInterval
    );
    this.Agregados$.subscribe((val: GrupoChuvaEstacao[]) => {
      console.log({val});
      this.rainAggregates.emit({
        estacoesTemposChuvas: val,
        resolucaoTempo: this.aggregateRainInterval,
        dataInicial: startDateTime,
        dataFinal: endDateTime,
      });
    });
  }

  /**
   * Calcula a diferença em dias entre as datas inicial e final, e define a configuração do
   * tipo de intervalo.
   */
  calcAggregateRainInterval() {
    let startDateTime = `${this.startDate} ${this.startTime}`;
    let endDateTime = `${this.endDate} ${this.endTime}`;

    let diff = (new Date(endDateTime).valueOf()) - (new Date(startDateTime).valueOf());
    let [days, hours, minutes] = this.timespanService.calcTimespan(diff);

    this.aggregateRainInterval = this.calcTimeResolution(days);
  }

  /**
   * Obtém os dados do tipo de intervalo, de acordo com o número de dias entre as datas
   * inicial e final 
   * 
   * @param days número de dias entre as datas inicial e final
   * @returns objeto de configuração do intervalo de tempo, com a palavra chave do intervalo no
   *    banco de dados, e o nome da coluna que deve ser usada para acessar o agregado de chuva.
   */
  calcTimeResolution(days: number): TimeResolution {
    
    if (days > TimeResolutionInDays.SIX_MONTHS) {
      return TimeResolution.ONE_MONTH;
    }
    if (days > TimeResolutionInDays.TWO_WEEKS) {
      return TimeResolution.ONE_DAY;
    }
      return TimeResolution.ONE_HOUR;
  }

    /**
     * Busca os registros dos eventos que ocorreram no tempo específico e atualiza o eventEmitter
     * rainEvents, passando esses registros recuperados.
     * 
     * @param startTimeId id do começo do intervalo de tempo
     * @param endTimeId id do final do intervalo de tempo
     */
     getEventValues(startTimeId: number, endTimeId: number) {
      
      let startDateTime = this.getStartDateTime();
      let endDateTime = this.getEndDateTime();

      this.Eventos$ = this.service.getEventDataByTimeId(startTimeId,endTimeId);
      this.Eventos$.subscribe(eventData => {
        const config: EventsConfig = {'events': eventData, 'startDate': startDateTime, 
          'endDate': endDateTime};
        this.rainEvents.emit(config);
      });
    }

  /**
   * Atualiza os valores dos campos de data e hora inicial e final.
   */
  setTimeFieldsToNow() {

    let end = new Date();
    let start = new Date();
    start.setMonth(start.getMonth() - 1);

    let [date, time] = this.timeFormatterService.dateParts(start);
    this.mapConfig.time.startDate = date;
    this.mapConfig.time.startTime = time;

    let [finalDate, finalTime] = this.timeFormatterService.dateParts(end);
    this.mapConfig.time.endDate = finalDate;
    this.mapConfig.time.endTime = finalTime;
  }

  updateEndDateTimeField() {

  }

  /**
   * 
   * @returns concatenação dos campos de data e hora iniciais, no formato 'YYYY-MM-DD hh:mm'
   */
  getStartDateTime() {
    return `${this.startDate} ${this.startTime}`;
  }

  /**
   * 
   * @returns concatenação dos campos de data e hora finais, no formato 'YYYY-MM-DD hh:mm'
   */
  getEndDateTime() {
    return `${this.endDate} ${this.endTime}`;
  }


  canSetTileSize(): boolean {
    return this.selectedHeatmapType == HeatmapType.HEATMAP;
  }

  /**
   * Verifica se é possível exibir o campo de entrada do tilesize (tamanho da célula da grade do heatmap em km).
   * A condição é satisfeita quando o usuário seleciona a opção "Heatmap" no campo "selectedHeatmapType".
   * 
   * @returns indica se é possível exibir o campo do tilesize ou não.
   */
   canSetIntervalo(): boolean {
    return this.selectedHeatmapType == 4;
  }


  /**
   * Verifica se é permitido remover as cores das layers (colorir de cinza).
   * No momento, apenas as layers de linhas das vias e dos rios podem ter as cores removidas.
   * 
   * @returns indica se a layer pode ter as cores removidas.
   */
  canResetColor() : boolean {

    return [HeatmapType.HIGHWAYS, HeatmapType.RIVERS].includes(this.selectedHeatmapType);
  }

  /**
   * Obtém os tipos de coloração (1: contínua; 2: discreta) selecionados para cada tipo de visualização
   * (estações, heatmap, vias e rios).
   * 
   * @returns um array contendo o número do tipo de coloração para as visualizações (estações, heatmap, vias, rios),
   *    nesta ordem.
   */
  getColorTypes(): number[] {
    return this.heatmapConfig.map(conf => conf.colorType);
  }

  /**
     * Disparado quando os campos do filtro mudam.
     * Verifica se o id_tempo é 0 antes de chamar o método de busca por dados de chuva.
     * Isso evita que a busca seja disparada quando o usuário só está configurando o filtro no início.
     * 
     * @param attr: tipo de atributo do mapconfig a ser mudado
     */
   onFilterChange(attr:"percentile"|"heatmapConfig"|"tilesize"|"source") {
    if (this.mapConfig == undefined || !this.testPercentile() || !this.testTileSize()) return;

    // if(attr == "percentile") this.mapConfig.layer.percentile = this.percentil
    // else if(attr == "heatmapConfig") this.mapConfig.layer.colors = this.getColorTypes()
    // else if(attr == "tilesize") this.mapConfig.layer.tilesizeInKm = this.heatmapConfig[1].tilesizeInKm
    // else if(attr == "source") {
    //   this.mapConfig.dataFilter.dataSource = this.dataSource;
    // }
    // else if (attr == "completeness") {
    //   this.mapConfig.dataFilter.completeness = this.completeness;
    // }
    this.json.emit();
  }


  /**
   * Usa uma análise selecionada para inicializar os campos do formulário de filtros e camadas.
   * @implements StartableFromRouter.startFromRouter
   * @param projeto 
   */
  startFromRouter(projeto:Analise){

    // /** Formata a data em uma string yyyy-mm-dd */
    // const formatDate = (date: Date) => {
    //   let year = date.getUTCFullYear().toString();
    //   let month = (date.getUTCMonth() + 1).toString();
    //   let day = date.getUTCDate().toString();

    //   const LPAD = MathAux.LPAD;

    //   return `${year}-${LPAD(month)}-${LPAD(day)}`;
    // };

    // /** Formata a data em uma string HH:MM */
    // const formatTime = (date: Date) => {
    //   let hour = date.getUTCHours().toString();
    //   let minute = date.getUTCMinutes().toString();

    //   const LPAD = MathAux.LPAD;

    //   return `${LPAD(hour)}:${LPAD(minute)}`;
    // };

    // this.startDate = formatDate(projeto.data_inicio);
    // this.startTime = formatTime(projeto.data_inicio);
    // this.endDate = formatDate(projeto.data_fim);
    // this.endTime = formatTime(projeto.data_fim);
    // this.tilesize = projeto.tilesize
    // this.percentil = [projeto.percentil_min,projeto.percentil_max]
    // this.intervalo = projeto.intervalo_horas_ocorrencias
    // this.heatmapConfig.forEach((val,index)=>{
    //   let camada = projeto.camadas.filter(val => (val.id_camada-1) == index)[0]
    //   if (camada != undefined) val.colorType = camada.coloracao as number
    // })
    // this.timestamp = projeto.coluna_selecionada;
    // // this.searchOnInterval()
    // this.useSocket();
  }

  /* generatePDF(){
    this.generateReport.emit();
  } */
}
